import { Button } from "./Button";
import { Drawer } from "./Drawer";

export function Alert({ title, subtitle, open, onClose }) {
  return (
    <Drawer
      open={open}
      alreadyDrawer
      direction="bottom-center"
      title={title}
      subtitle={subtitle}
    >
      <Button
        design="primary"
        className="w-100"
        onClick={() => onClose()}
      >
        Fechar
      </Button>
    </Drawer>
  );
}
